import { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { MeetingType } from '../../types/meetingType';

interface MeetingTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
}

export function MeetingTypeSelect({ value, onChange, required, disabled }: MeetingTypeSelectProps) {
  const [meetingTypes, setMeetingTypes] = useState<MeetingType[]>([]);

  useEffect(() => {
    const fetchMeetingTypes = async () => {
      const q = query(collection(db, 'meetingTypes'), orderBy('name'));
      const querySnapshot = await getDocs(q);
      const types = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as MeetingType[];
      setMeetingTypes(types);
    };

    fetchMeetingTypes();
  }, []);

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-600 mb-1">
        Type de rencontre
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={disabled}
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#00665C] focus:border-[#00665C] ${
          disabled ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      >
        <option value="">Sélectionner un type</option>
        {meetingTypes.map((type) => (
          <option key={type.id} value={type.id}>
            {type.name}
          </option>
        ))}
      </select>
    </div>
  );
}